<!--新增坏件单-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"  >
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="300">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80" v-if="addtype!=1">责任人：</td>
          <td colspan="4" v-if="addtype!=1">
            <CommonTree ref="treeDserial" :treeHeight="180" :searchText="form.applyby" :inputSize="'mini'" @check="checktree1"></CommonTree>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="80">产&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td colspan="6">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="600"
                        :treeHeight="400" :searchText="form.seedname"
                        @check="afterSelectCode"></CommonTree>
          </td>
        </tr>
        <tr class="noborder" v-if="addtype!=1">
          <td align="right" width="60">入库原因：</td>
          <td colspan="5">
            <el-radio-group v-model="ordername">
            <el-radio label="验光原因">验光原因</el-radio>
            <el-radio label="顾客原因">顾客原因</el-radio>
            <el-radio label="质量问题">质量问题</el-radio>
            <el-radio label="加工损坏">加工损坏</el-radio>
            <el-radio label="商品过期">商品过期</el-radio>
            <el-radio label="其他原因">其他原因</el-radio>
          </el-radio-group>
          </td>
        </tr>

        <tr class="noborder" v-if="addtype==1">
          <td align="right" width="60">供应商：</td>
          <td width="140">
            <el-select v-model="controlData.pcustomerserial" placeholder="请选择" size="mini" @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
          <td align="right">供应号：</td>
          <td>
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号" @change="scanTracknum"
                      onfocus="this.select()"></el-input>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">备注：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 40px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
        <!--<tr class="noborder" v-if="addtype==1">-->
         <!---->
          <!--<td align="right">跟踪号：</td>-->
          <!--<td>-->
            <!--<el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请输入跟踪单号"-->
                      <!--onfocus="this.select()"-->
            <!--&gt;</el-input>-->
          <!--</td>-->
          <!--<td align="right"></td>-->
          <!--<td></td>-->
        <!--</tr>-->
        <tr class="noborder" v-if="showerweitable">
          <td colspan="6">
            <el-table
              :data="tableData" v-if="isyinxin"
              :height="tableHeight(200)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="certorg" :show-overflow-tooltip="true"
                label="厂家"
                align="left" width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="certno" :show-overflow-tooltip="true"
                label="注册证号"
                align="left" width="160"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="batchno" :show-overflow-tooltip="true"
                label="批次号"
                align="left" width="120"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="endtime" :show-overflow-tooltip="true"
                label="失效日期"
                align="left"  width="100"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.endtime?scope.row.endtime.split(' ')[0]:''}}
                </template>
              </el-table-column>
              <el-table-column
                prop="Y"
                label="球镜"
                align="left"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="X"
                label="柱镜"
                align="left"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="P"
                label="库存"
                align="center"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="转入数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" style="width: 100%" :min="0" :max="scope.row.P" size="small" v-model="scope.row.totalnumber"
                                   :ref='scope.row.id'
                                   onfocus="this.select()"
                                   @change="totalNumber"></el-input-number>
                </template>
              </el-table-column>
              <!--<el-table-column label="操作" align="center" width="100">-->
              <!--<template slot-scope="scope">-->
              <!--<el-button size="mini" type="danger"-->
              <!--@click="handleDelete(scope.$index, scope.row)">删除-->
              <!--</el-button>-->
              <!--</template>-->
              <!--</el-table-column>-->
            </el-table>
            <TwoDimensionalTable ref="referweibiao" v-else :cutHeight="311" :erweitable="erweitable" :enablenegative="true"
            ></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-if="showzuoyoutable">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoright" :cutHeight="311" :erweitable="erweitableright" :enablenegative="true"
              ></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoleft" :cutHeight="311" :erweitable="erweitableleft" :enablenegative="true"
              ></TwoDimensionalTable>
            </el-col>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">确认</el-button>&nbsp;&nbsp;<span v-if="isyinxin">总数：{{totalnumber}}</span>
    </div>
  </el-dialog>
</template>


<script>
  import {getRemark} from '@/plugin/ordercommon'
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {getPrice} from '@/api/set/goodsprice';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {suppliers} from '@/api/set/externaldept';
  import {addstoragebad} from '@/api/set/warehouse'
  import {getListData} from '@/api/set/jxcstore'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getDetail} from '@/api/set/jxcstoregoodsbarcode';
  import {getListData as listCert} from '@/api/set/certmanage'

  export default {
    name: 'AddStorageBad',
    msg:'仓库岗 添加坏件（供应商多发、正式库转入）',
    data() {
      return {
        book: {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []},
        erweitable: [],//二维表
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        costpricebook: {},
        dialogFormVisible: false,
        goodsbarcode:'',
        title: "",
        categorycode:"",
        isyinxin:false,
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        remark: '',
        cangkucode: '',
        cangkuname: '',
        ordername:'',
        cangkucodes: [],
        tableData: [
          {column: []},
        ],
        addtype:1,
        tableData1: [],
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        storenumtable: [],
        totalnumber: 0,//镜架 调拨总数
        showtitle1: "none",
        jxcstoreData: [],
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        showshuliangxuanze: false,
        num: 0,
        canshowgoodsel: true,
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          applybyguid:"",
          applyby:""
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        loading: false,
        scangoodscode:[]
      }

    },
    methods: {
      checktree1(guids, names, arr) {
        this.form.applybyguid = guids;
        this.form.applyby = names;
      },
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          if(this.tableData[i].totalnumber==undefined)
            continue;
          var num = parseInt(this.tableData[i].totalnumber);
          this.totalnumber = this.totalnumber + num
        }
      },
      //供应商单号输入成功后自动跳到跟踪单号框
      scanTracknum() {
        if (this.tracknum) {
          this.$refs.logisticstracknum.focus()
        }
      },
      //获得标题
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件入库单"
        return result
      },
      //清空商品
      clearSeedCode() {
        this.scangoodscode=[]
        this.form.seedcode = ""
        this.form.seedname = ""
        this.form.filltemplate = ""
        this.canshowgoodsel = false
      },
      bindData() {
        if(!this.$refs.treeSeed) return;

        this.$refs.treeSeed.bindData(() => {
          var row = {filltemplates: '10;20;30'};
          if (this.addtype != 1) {
            row.nostock = "1";
          }
          return getGoodsTree(row)
        })
      },
      //选择供应商
      changepcu(val) {
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            this.controlData.clinkman = this.ptableData[i].linkman
            this.controlData.clinkmantel = this.ptableData[i].linkmantel
            this.controlData.caddress = this.ptableData[i].address
            this.BookContent = []
          }
        }
        if (val) {
          this.getXYRange()
        }
      },
      //选择商品之后执行
      afterSelectCode(guids, names, arr) {
        this.scangoodscode=[]
        this.form.seedcode = guids
        this.form.seedname = names
        this.filltemplate = arr[0].attributes.filltemplate
        this.categorycode = arr[0].parentId;

        this.costpricebook = {}
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.filltemplate == '30') {//左右眼
          this.showzuoyoutable = true
          this.showerweitable = false
          this.showshuliangxuanze = false
        } else if (this.filltemplate == '10' || this.filltemplate == '20') {
          this.showzuoyoutable = false
          this.showerweitable = true
          this.showshuliangxuanze = false
        } else if (this.filltemplate == '40') {
          this.showzuoyoutable = false
          this.showerweitable = false
          this.showshuliangxuanze = true
        }

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }

        this.isyinxin=this.categorycode.startsWith("010");
        if (this.isyinxin) {
          listCert({offset: 0, limit: 1, certtype: 1, seedcode: this.form.seedcode}).then(response => {
            if (!(response.data.code == 0 && response.data.obj.rows.length > 0)) {
              this.isyinxin=false;
            }
            this.geterweibiao();
          })
        } else {
          this.geterweibiao();
        }
      },
      //判断当前供应商是否存在
      geterweibiao() {
        this.controlData.pcustomerserial = ''
        this.controlData.pcustomer = ''
        if (this.addtype == 1) {
          this.costpricebook = {}
          suppliers({seedcodes: '["' + this.form.seedcode + '"]'}).then((response) => {
            this.ptableData = response.data.obj
            if (this.ptableData.length > 0) {
              this.controlData.pcustomerserial = this.ptableData[0].customerserial
              this.controlData.pcustomer = this.ptableData[0].deptname
              this.getXYRange()
            }
          })
        } else {
          this.getXYRange()
        }
      },
      getXYRange() {
        if(this.isyinxin){//隐形直接显示库存选择
          this.bindStore();
          return;
        }

        getPrice({
          seedcode: this.form.seedcode,
          customerSerial: '',//this.controlData.pcustomerserial,
          filterType: 'cost'
        }).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          this.createPriceBook()
        })
      },

      //绑定库存
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1

        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          nolimit: 1,
          nodeliverying: 1,
          nobuynum: 1,
          cangkucode: this.controlData.cangkucode,
          calculateStore: "1",
          showyinxing: this.isyinxin ? "1" : "0"
        }).then(resStore => {
          this.tableData = [];
          if (resStore.data.obj.length == 0)
            return;

          if (this.isyinxin) {
            resStore.data.obj.forEach(o => {
              let ob = JSON.parse(o.packagesize)
              o.X = ob.X;
              o.Y = ob.Y;
              o.P = o.totalnumber;
              o.totalnumber = undefined;
              this.tableData.push(o);//本次调拨的隐形数量
            })
            this.totalNumber();
            this.tableData.sort(function (a, b) {
              let aP = JSON.parse(a.packagesize)
              let bP = JSON.parse(b.packagesize)
              if (aP.X == bP.X) {
                if (aP.Y == '0.00') aP.Y = "-0.00";
                if (bP.Y == '0.00') bP.Y = "-0.00";
                return aP.Y.localeCompare(bP.Y)
              }
              else {
                if (aP.X == '0.00') aP.X = "-0.00";
                if (bP.X == '0.00') bP.X = "-0.00";
                return aP.X.localeCompare(bP.X)
              }
            });
            return;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      createPriceBook() {
        if (this.filltemplate == 30) {
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight)
        } else if (this.filltemplate == '10' || this.filltemplate == '20') {
          this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
        if(this.isyinxin){//隐形直接显示库存选择
          this.bindStore();
          return;
        }

        this.BookContent = []
        this.createPriceBook()
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },

      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },

      saveData() {
        this.loading = true
        //根据缓存中oddrequired  true需必填否则不必填
        if (this.addtype==1) {
          this.ordername='供应商多发';
          if (!this.tracknum) {
            this.$message({
              message: '请输入供应商单号',
              type: 'error'
            })
            this.loading = false
            return
          }
        }else {
          if (!this.form.applybyguid) {
            this.$message({
              message: '责任人必选！',
              type: 'error'
            })
            this.loading = false
            return
          }
          if (!this.ordername) {
            this.$message({
              message: '请选择入库原因！',
              type: 'error'
            })
            this.loading = false
            return
          }
          if (this.ordername == '其他原因' && !this.controlData.remark) {
            this.$message({
              message: '请填写备注！',
              type: 'error'
            })
            this.loading = false
            return
          }
        }

        //取出对应的表单详情和数量
        var arr = [];
        var barcode = [];
        if(this.isyinxin){
          for (let i in this.tableData) {
            var obj = {}
            if (this.tableData[i].totalnumber!=undefined&&parseInt(this.tableData[i].totalnumber) > 0) {
              obj.X = this.tableData[i].X
              obj.Y = this.tableData[i].Y;
              obj.P = this.tableData[i].totalnumber
              arr.push(obj)

              barcode.push(this.tableData[i]);
            }
          }
        }else if (this.filltemplate == "30") {//左右眼
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {
              t.type = "L"
              return typeof(t.P) != "undefined" && t.P !== ""&&parseInt(t.P)> 0;
            })
            arr = arr.concat(temp)
          }
          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              t.type = "R"
              return typeof(t.P) != "undefined" && t.P !== ""&& parseInt(t.P) > 0;
            })
            arr = arr.concat(temp)
          }
        }
        else if (this.filltemplate == '10' || this.filltemplate == '20') {//非左右眼
          for (let i in   this.erweitable) {
            let temp = this.erweitable[i].filter((t) => {
              return typeof(t.P) != "undefined" && t.P !== ""&& parseInt(t.P) > 0;
            })
            arr = arr.concat(temp)
          }
        } else if (this.filltemplate == '40') {
          let packsize = {};
          if (this.num && parseInt(this.num) > 0) {
            packsize.P = this.num;
            arr.push(packsize)
          }
        }
        if (arr.length == 0) {
          this.$message({
            message: '输入数量',
            type: 'warning'
          })
          this.loading = false
          return
        }
        for(let i in this.scangoodscode){
          this.scangoodscode[i].cangkucode=this.controlData.cangkucode;
          this.scangoodscode[i].seedcode=this.form.seedcode;
        }
        var scancodes=JSON.stringify(this.scangoodscode);

        if (arr != 0) {
          addstoragebad({
            jxcforms: JSON.stringify(arr),
            map: JSON.stringify({
              pcustomerserial: this.controlData.pcustomerserial,
              pcustomer: this.controlData.pcustomer,
              cangkuname: this.controlData.cangkuname,
              cangkucode: this.controlData.cangkucode,
              address: this.controlData.address,
              linkman: this.controlData.linkman,
              linkmantel: this.controlData.linkmantel,
              seedcode: this.form.seedcode,
              seedname: this.form.seedname,
              remark: this.controlData.remark,
              tracknum: this.tracknum,
              logisticstracknum: this.logisticstracknum,
              addtype: this.addtype,
              ordername: this.ordername,
              applyby: this.form.applyby,
              applybyguid: this.form.applybyguid,
              scancodes: scancodes
            }),
            barcode: barcode.length > 0 ? JSON.stringify(barcode) : ''
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$emit('bindGrid');
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.dialogSeeVisible = false;
            //刷新列表
          });
          //

        } else {
          this.$message({
            message: '请选择订单',
            type: 'error'
          })
          this.loading = false
        }

      },


      initData(type) {
        if(this.addtype!=type){
          this.addtype=type;//1 供应商多发，2 正式转入
          this.bindData();
        }
        this.initForm()
        if (this.jxcstoreData && this.jxcstoreData.length > 0) {
          this.controlData.cangkucode = this.jxcstoreData[0].cangkucode
          this.controlData.cangkuname = this.jxcstoreData[0].cangkuname
        }

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.costpricebook = ""
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
          this.book = {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []}
          this.erweitable = []
        }
      },


      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.scangoodscode=[]
        this.canshowgoodsel = true
        this.controlData = {}
        this.groupguid = ""
        this.column = []
        this.ordername=""
        this.tableData = []
        this.unitguid = ""
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        this.showzuoyoutable = false
        this.showerweitable = false
        this.showshuliangxuanze = false
        this.filltemplate = ""
        this.index = -99
        this.addvisible = true
        this.form.seedcode = ''
        this.form.seedname = ''
        this.form.applyby=''
        this.form.applybyguid=''
        this.num = 0;
        this.loading = false
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
      }
    },
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj

      })
    },

    components: {
      TwoDimensionalTable,
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AddStorageBad.vue